module.exports = __webpack_public_path__ + "static/media/banner-rm.2a8fb656.jpg";